export default __webpack_public_path__ + "static/media/yumyum-widget-button.fcaab88c.webp";